import { PublicClientApplication, Configuration, RedirectRequest } from "@azure/msal-browser";
import { entraConfig } from "../config/entraConfig";

const msalConfig: Configuration = {
  auth: {
    clientId: entraConfig.clientId,
    authority: entraConfig.authority,
    redirectUri: entraConfig.redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: entraConfig.scopes,
  redirectUri: entraConfig.redirectUri,
};

export const logoutRequest = {
  postLogoutRedirectUri: entraConfig.postLogoutRedirectUri,
};
